module.exports = __webpack_public_path__ + "img/zoom-one-text.8bb67c9f.svg";